import { render } from "./Blog6View.vue?vue&type=template&id=702791db"
import script from "./Blog6View.vue?vue&type=script&lang=js"
export * from "./Blog6View.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__